import filter from 'lodash/filter'
import sumBy from 'lodash/sumBy'
import cloneDeep from 'lodash/cloneDeep'
import * as model from 'app/features/orders/models'
import {deliveryTypes} from 'app/constant'

export const mapToUpdateDraft = ({id, ...draftOrder}: any) => {
  return {
    patch: draftOrder,
    id,
  }
}

export const mapToCreateShippingRateAndTaxInput = (draftOrder: any, shippingMethod: any) => {
  return {
    patch: {
      totalPrice: totalPrice(draftOrder, shippingMethod.rate),
      shippingPrice: shippingMethod.rate,
      shippingRate: {
        create: mapToShippingRate(shippingMethod),
      },
    },
    id: draftOrder.id,
  }
}

export const mapToUpdateShippingRateInput = (draftOrder: any, shippingMethod: any) => {
  const {shippingRateId}: any = draftOrder
  return {
    totalPrice: totalPrice(draftOrder, shippingMethod.rate),
    shippingPrice: shippingMethod.rate,
    shippingRate: {
      updateById: {
        patch: mapToShippingRate(shippingMethod),
        id: shippingRateId,
      },
    },
  }
}

export const mapToUpdateTax = (draftOrder: any) => {
  return {
    totalPrice: draftOrder.totalPrice,
    totalTax: draftOrder.totalTax,
  }
}

export const checkIsEdited = async (items: any[]) => {
  return filter(items, (item: any) => item.dirtyField === true)
}

const mapToShippingRate = (shippingMethod: any) => {
  return {
    serviceId: shippingMethod.serviceId,
    price: shippingMethod.rate,
    originalPrice: shippingMethod?.originalRate,
    discount: shippingMethod?.discount,
    title: shippingMethod.serviceName,
    serviceType: shippingMethod.serviceType,
    carrierType: shippingMethod.carrierType,
    handlingFee: shippingMethod?.handlingFee,
    providerShippingPrice: shippingMethod?.providerShippingPrice,
  }
}

export const totalPrice = (order: model.DraftOrder, price: any) => {
  return (
    order.subtotalPrice +
    order.totalTax +
    parseFloat(price || 0) -
    order.totalDiscounts -
    order.wineClubDiscounts
  )
}

// export const totalPrice2 = (order: model.DraftOrder, totalTax: any) => {
//   return (
//     order.subtotalPrice +
//     order.shippingPrice +
//     totalTax -
//     order.totalDiscounts -
//     order.wineClubDiscounts
//   )
// }

export const sellingPrice = (item: any) => {
  return parseFloat(item.discountPrice) > 0
    ? parseFloat(item.discountPrice)
    : parseFloat(item.price)
}

export const validateDraftOrderShipping = ({
  orderDeliveryMethod,
  shippingRateId,
  isFreeShipping,
}: any) => {
  if (isFreeShipping && orderDeliveryMethod === deliveryTypes.ship) {
    return true
  }

  if (orderDeliveryMethod === deliveryTypes.ship) {
    return !!shippingRateId
  }

  return true
}

export const sumOfWithOutTipAmount = (items: any[]) => {
  const amount = sumBy(items, (item: any) => {
    if (item.tipAmount) {
      return parseFloat(item.tipAmount)
    }
    return 0
  })

  return amount
}

export const calculate = (items: any[]) => {
  const amount = sumBy(items, (item: any) => {
    if (item.withoutTipAmount) {
      return parseFloat(item.withoutTipAmount)
    }
    return 0
  })

  return amount
}

export const isShowCrv = (param: any) => {
  if (param.isCrv && param.totalTax > 0 && param.crv > 0) {
    return true
  }
  return false
}

export const formatPhoneNumber = (phone: string) => {
  const phoneRegex = /^(\d{3})(\d{3})(\d{4})$/
  const match = phone.replace(/\D/g, '').match(phoneRegex)
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }
  return phone
}

//  code defines a function mapToVariantModel that takes an array of variants as input.
//  sets specific properties to a large number 9007199254740991 if isAllowNegativeInventory function returns true for a variant,
//  and then returns a new array of modified variants

export const mapToVariantAllowNegativeInventoryModel = (variants: any[]) => {
  return variants.map((variant: any) => {
    const _variant = cloneDeep(variant)
    if (isAllowNegativeInventory(variant)) {
      const maxNumber = 9007199254740991
      _variant.available = maxNumber
      _variant.shipAvailableForAdminPortal = maxNumber
      _variant.pickupAvailableForAdminPortal = maxNumber
      _variant.variant.available = maxNumber
      _variant.variant.shipAvailableForAdminPortal = maxNumber
      _variant.variant.pickupAvailableForAdminPortal = maxNumber
    } else if (parseInt(_variant.available) === 0) {
      _variant.available =
        parseInt(_variant.shipAvailableForAdminPortal || 0) +
        parseInt(_variant.pickupAvailableForAdminPortal || 0)
    }
    return {..._variant}
  })
}

const isAllowNegativeInventory = ({variant}: any) => {
  if (variant.inventoryItem && variant.inventoryItem.canAllowNegativeInventory) {
    return true
  }
  return false
}
